import { RouteConfig } from 'vue-router';
const SupportPanel = () =>
    import(/* webpackChunkName: "panel" */ '~/views/SupportPanel.vue');


// creates an array with all the support panel routes in the format:
// {
//     path: '/user/:userIdentifier/home/:homeId/gateway/:gatewayId',
//     name 'user-home-gateway',
//     component: SupportPanel,
//     props: true,
// }
export function createSupportPanelRoutes(): RouteConfig[] {
    const USER = 0;
    const HOME = 1;
    const GATEWAY = 2;
    const MODULE = 3;

    const routeElements = [
        {
            pathParticle: 'user',
            routeNameParticle: 'user',
            parameter: 'userIdentifier',
        },
        {
            pathParticle: 'home',
            routeNameParticle: 'home',
            parameter: 'homeId',
        },
        {
            pathParticle: 'gateway',
            routeNameParticle: 'gateway',
            parameter: 'gatewayId',
        },
        {
            pathParticle: 'module',
            routeNameParticle: 'module',
            parameter: 'moduleId',
        },
    ];

    // creates a routes array with the array from params for example
    // [
    //     [USER, HOME],
    //     [USER, HOME, GATEWAY],
    // ]
    // to create routes for
    // /user/:userIdentifier/home/:homeId
    // /user/:userIdentifier/home/:homeId/gateway/:gatewayId
    function createRoutes(arrayOfElementsArray: number[][]) {

        // creates a route by iterating through the elements array
        // for example [USER, HOME, GATEWAY]
        // creates a route {
        //     path: '/user/:userIdentifier/home/:homeId/gateway/:gatewayId',
        //     name 'user-home-gateway',
        //     component: SupportPanel,
        //     props: true,
        // }
        function createRoute(elementsArray: number[]) {
            let path = '';
            let name = '';
            const nameSeparator = '-';
            elementsArray.forEach((element, index) => {
                const { pathParticle, routeNameParticle, parameter } = routeElements[element];
                path = `${path}/${pathParticle}/:${parameter}`;
                name = `${name}${index > 0 ? nameSeparator : ''}${routeNameParticle}`;
            });
            return {
                path: `/support${path}`,
                name,
                component: SupportPanel,
                props: true,
            };
        }
        return arrayOfElementsArray.map((elementsArray) => createRoute(elementsArray));
    }

    const routes = createRoutes([
        [USER, HOME],
        [USER, HOME, GATEWAY],
        [USER, HOME, GATEWAY, MODULE],
        [USER, GATEWAY],
        [USER, GATEWAY, MODULE],
        [HOME],
        [HOME, GATEWAY],
        [HOME, GATEWAY, MODULE],
        [GATEWAY],
        [GATEWAY, MODULE],
    ]);
    return routes;
}

export const supportPanelRoutes = createSupportPanelRoutes();
